import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, KeyRound, Shield, LogOut } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Badge } from "@/components/ui/badge";

export default function AppNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const links = [
    { to: "/dashboard", label: "Projects", icon: LayoutGrid },
    { to: "/settings", label: "API Keys", icon: KeyRound },
  ];
  if (user?.role === "admin") links.push({ to: "/admin", label: "Admin", icon: Shield });

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Logo />
          <nav className="hidden sm:flex items-center gap-1">
            {links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
                  pathname === l.to ? "bg-secondary text-white" : "text-muted-foreground hover:text-white hover:bg-secondary/60"
                }`}>
                <l.icon className="w-4 h-4" /> {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger data-testid="user-menu" className="flex items-center gap-2 outline-none">
            <Badge variant="outline" className="font-mono text-[10px] uppercase border-kinetic/40 text-kinetic">{user?.role}</Badge>
            <span className="h-8 w-8 rounded-full bg-secondary flex items-center justify-center text-sm font-semibold">
              {(user?.name || user?.email || "?")[0].toUpperCase()}
            </span>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="bg-popover border-border w-52">
            <div className="px-2 py-1.5 text-xs text-muted-foreground truncate">{user?.email}</div>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => navigate("/settings")} className="cursor-pointer">
              <KeyRound className="w-4 h-4 mr-2" /> API Keys
            </DropdownMenuItem>
            <DropdownMenuItem data-testid="logout-btn" onClick={async () => { await logout(); navigate("/login"); }}
              className="cursor-pointer text-kinetic focus:text-kinetic">
              <LogOut className="w-4 h-4 mr-2" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
